/*----------------------
    VERTICAL SLIDER
---------------------- */

verticalSlider = {
    init: function () {
        new Swiper('.swiper--vertical-slider', {
            slidesPerView: "auto",
            loop: true,
            freeMode: true,
            speed:5000,
            allowTouchMove: false,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
        });
    }
};


$(function () {
    verticalSlider.init();
});